import { useEffect, useRef, useState } from "react";

export default function Reveal({
  children,
  delay = 0, // ms
  as: Tag = "div",
  className = "",
  threshold = 0.2, // how much must be visible to trigger
  replay = true, // <— animate again when it comes back into view
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else if (replay) {
          // when it leaves viewport, reset so it can animate again next time
          setVisible(false);
        }
      },
      { threshold }
    );

    io.observe(el);
    return () => io.disconnect();
  }, [threshold, replay]);

  return (
    <Tag
      ref={ref}
      className={className}
      style={{
        transition: "transform 600ms ease, opacity 600ms ease",
        transitionDelay: `${delay}ms`,
        transform: visible ? "translateY(0)" : "translateY(16px)",
        opacity: visible ? 1 : 0,
        willChange: "transform, opacity",
      }}
    >
      {children}
    </Tag>
  );
}
